import axios from "axios"

import config from "@/app.config"
import store from "@/store"
import { ErrorHandlerCaller as EHC, E401 } from "./errors"
import { isObjectDate, isISODate, stringToDate, toISODatetimeUTC } from "./datetime"

class DateSerializer {
  static serialize(data) {
    if (typeof data === "string" && isISODate(data)) {
      return stringToDate(data)
    }
    if (Array.isArray(data)) {
      return data.map(DateSerializer.serialize)
    }
    if (typeof data === "object" && data !== null) {
      return Object.fromEntries(
        Object.entries(data).map(([key, value]) => [key, DateSerializer.serialize(value)])
      )
    }
    return data
  }

  static deserialize(data) {
    if (isObjectDate(data)) {
      return toISODatetimeUTC(data)
    }
    if (Array.isArray(data)) {
      return data.map(DateSerializer.deserialize)
    }
    if (!(data instanceof FormData) && typeof data === "object" && data !== null) {
      return Object.fromEntries(
        Object.entries(data).map(([key, value]) => [key, DateSerializer.deserialize(value)])
      )
    }
    return data
  }
}

/**
 * HTTP MODULE
 */

const BACKEND_API_URL = config.general.api
const ERROR_HANDLER = new EHC([new E401()])
const SERIALIZERS = [DateSerializer]

const HTTP = axios.create({
  baseURL: BACKEND_API_URL,
  timeout: 180000
})

// Intercept REQUEST
HTTP.interceptors.request.use(config => {
  // Add authorization header
  if (store.state.app.user != null) {
    config.headers.authorization = "Token " + store.state.app.user.key
    if (store.state.app.user.tzName) {
      config.headers["X-Timezone-Name"] = store.state.app.user.tzName
    }
  }

  if (config.data) {
    // Deserialize and update config.data if required
    SERIALIZERS.forEach(klass => (config.data = klass.deserialize(config.data)))
  }
  return config
})

// Intercept RESPONSE
HTTP.interceptors.response.use(
  response => {
    if (
      response.data &&
      !(response.data instanceof Blob) &&
      !(response.data instanceof ArrayBuffer)
    ) {
      // Serialize and update response.data if required
      SERIALIZERS.forEach(klass => (response.data = klass.serialize(response.data)))
    }
    return response
  },
  error => {
    ERROR_HANDLER.intercept(error)
    return Promise.reject(error)
  }
)

export { HTTP, BACKEND_API_URL }
